import { Badge, HStack } from "@chakra-ui/react";
import { useState } from "react";
import {
  IoChevronBackCircleOutline,
  IoChevronForwardCircleOutline,
} from "react-icons/io5";

export const usePaginateComponent = () => {
  const [pagination, setPagination] = useState({
    page: 1,
    previousPage: null,
    lastPage: null,
  });

  const updatePagination = (data) => {
    return {
      page: data.current_page,
      lastPage: data.last_page,
      previousPage: data.prev_page_url ? data.current_page - 1 : null,
    };
  };

  return { PaginationComponent, pagination, setPagination, updatePagination };
};

function PaginationComponent({ pagination, getListData }) {
  const { page, lastPage } = pagination;

  const MAX_PAGES_DISPLAYED = 3;

  let startPage = Math.max(1, page - Math.floor(MAX_PAGES_DISPLAYED / 2));
  let endPage = Math.min(startPage + MAX_PAGES_DISPLAYED - 1, lastPage);

  if (endPage - startPage + 1 < MAX_PAGES_DISPLAYED) {
    startPage = Math.max(1, endPage - MAX_PAGES_DISPLAYED + 1);
  }

  const pageButtons = [];

  for (let i = startPage; i <= endPage; i++) {
    pageButtons.push(
      <Badge
        key={i}
        padding={"2"}
        color={i === page ? "white" : "gray.500"}
        border={i === page ? "none" : "1px solid #AB152F"}
        bg={i === page ? "gray.500" : "white"}
        cursor="pointer"
        onClick={() => getListData(i)}
      >
        {i}
      </Badge>
    );
  }

  return (
    <HStack my={"auto"} spacing={"2"} mx={"5"} justifyContent={"center"}>
      {page > 1 && (
        <IoChevronBackCircleOutline
          fontSize={"24"}
          color={"#AB152F"}
          onClick={() => getListData(page - 1)}
          cursor={"pointer"}
        />
      )}

      {pageButtons}

      {page < lastPage && (
        <IoChevronForwardCircleOutline
          fontSize={"24"}
          color={"#AB152F"}
          cursor={"pointer"}
          onClick={() => getListData(page + 1)}
        />
      )}
    </HStack>
  );
}
